import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, filter, finalize, map, switchMap } from 'rxjs/operators';
import { AuthPingService } from '../auth/auth-ping.service';
import { AuthStateService } from '../auth/auth-state-service';
import { TokenService } from '../services/tokenservice/token.service';
import { LoadingService } from '../services/loadingservice/loading.service';

export const PingGuardServiceFunction: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const pingGuardService = inject(PingGuardService);
  return pingGuardService.canActivate(route, state);
};

@Injectable({
  providedIn: 'root',
})
export class PingGuardService  {
  constructor(
    private authPingService: AuthPingService,
    private router: Router,
    private authStateService: AuthStateService,
    private tokenService: TokenService,
    private loadingService: LoadingService

  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const code = route.queryParams['code'];

    return this.authStateService.CurrentAuthorizationState.pipe(
      filter((authState) => authState === 'GOV_FINALIZADO' || authState === null),
      switchMap(() => {
        if (this.tokenService.hasValidToken()) {
          return of(true);
        }

        if (this.authStateService.getAuthMethod() === 'ping' && code) {
          this.loadingService.show();

          return this.authPingService.obtainToken(code).pipe(
            map((response) => {
              if (response?.access_token) {
                this.tokenService.setToken(response.access_token);
                return true;
              }
              return false;
            }),
            catchError((error) => {
              console.error('Erro ao obter o token:', error);
              this.router.navigate(['/home']);
              return of(false);
            }),
            finalize(() => {
              this.loadingService.hide();
            })
          );
        } else {
          this.router.navigate(['/home']);
          return of(false);
        }
      })
    );
  }
}
